<template>
  <div class="filter" :class="{ '--is-active': activeButton > 0 }">
    <!-- <span class="filter-title">Filter:</span> -->
    <div
      class="filter-option"
      :class="{ '--is-active': activeButton === 6 }"
    >
      <Button
        appearance="secondary"
        class="--flex-button"
        :class="{ '--is-active': activeButton === 6 }"
        @click="showFilter(6)"
      >
        Delikatessen
        <i class="icon icon-angle-up" v-if="activeButton === 6"></i>
        <i class="icon icon-angle-down" v-else></i>
      </Button>

      <div class="filter-panel panel --has-no-padding form__check" v-if="activeButton === 6">
        <ul>
          <li>
            <input
              type="search"
              placeholder="Delikatessen suchen"
              class="form__control"
              v-model="categorySearch"
              @keyup="createFiltersLevel3()"
              @search="createFiltersLevel3()"
            />
          </li>
          <li v-for="(category, index) in filterCache.categories" :key="category">
            <input
              class="form-check__input category-input"
              type="checkbox"
              :id="'filter[categories][' + index + ']'"
              :checked="
                $store.getters.getLevel3Filter.categories.includes(category)
              "
              @change="level3CategoryChange($event.target.checked, category)"
            />
            <label :for="'filter[categories][' + index + ']'">
              {{
              category
              }}
            </label>
          </li>
          <li class="--button-line">
            <Button appearance="primary" @click="showFilter(6)">Filter anwenden</Button>
            <a @click="level3CategoryClear()">Filter löschen</a>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="filter-option"
      :class="{ '--is-active': activeButton === 1 }"
      v-if="!$store.getters.isB2b"
    >
      <Button
        appearance="secondary"
        class="--flex-button"
        :class="{ '--is-active': activeButton === 1 }"
        @click="showFilter(1)"
      >
        Marke
        <i class="icon icon-angle-up" v-if="activeButton === 1"></i>
        <i class="icon icon-angle-down" v-else></i>
      </Button>

      <div class="filter-panel panel --has-no-padding form__check" v-if="activeButton === 1">
        <ul>
          <li>
            <input
              type="text"
              placeholder="Marke suchen"
              class="form__control"
              v-model="brandSearch"
              @keyup="createFiltersLevel3()"
              @search="createFiltersLevel3()"
            />
          </li>
          <li v-for="(brand, index) in filterCache.brands" :key="brand">
            <input
              class="form-check__input brand-input"
              type="checkbox"
              :id="'filter[brands][' + index + ']'"
              :checked="$store.getters.getLevel3Filter.brands.includes(brand)"
              @change="level3BrandChange($event.target.checked, brand)"
            />
            <label :for="'filter[brands][' + index + ']'">{{ brand }}</label>
          </li>
          <li class="--button-line">
            <Button appearance="primary" @click="showFilter(1)">Filter anwenden</Button>
            <a @click="level3BrandClear()">Filter löschen</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="filter-option" :class="{ '--is-active': activeButton === 2 }">
      <Button
        appearance="secondary"
        class="--flex-button"
        :class="{ '--is-active': activeButton === 2 }"
        @click="showFilter(2)"
      >
        Preis
        <i class="icon icon-angle-up" v-if="activeButton === 2"></i>
        <i class="icon icon-angle-down" v-else></i>
      </Button>

      <div class="filter-panel panel --has-no-padding form__check" v-if="activeButton === 2">
        <ul>
          <li>
            <vue-slider
              v-if="loadedCash"
              v-model="priceRange"
              :min="filterCache.min"
              :max="filterCache.max"
              :min-range="1"
              :enable-cross="false"
              :tooltip="'none'"
              @change="level3PriceChange"
            ></vue-slider>
          </li>
          <li class="--price-filter">
            <div>
              <span>Min. Preis €</span>
              <input type="text" class="form__control" v-model="minInput" ref="minPrice" @click="selectMin" />
            </div>
            <div>
              <span>Max. Preis €</span>
              <input type="text" class="form__control" v-model="maxInput" ref="maxPrice" @click="selectMax" />
            </div>
          </li>
          <li v-if="$store.getters.isB2b">
            <input
              class="form-check__input attribute-input"
              type="checkbox"
              :id="'filter[b2b][useB2c]'"
              :checked="$store.getters.getLevel3Filter.useB2cPrices"
              @change="level3UseB2cPrices($event.target.checked)"
            />
            <label :for="'filter[b2b][useB2c]'">brutto (inkl. Mwst.)</label>
          </li>
          <li class="--button-line">
            <Button appearance="primary" @click="showFilter(2)">Filter anwenden</Button>
            <a @click="level3PriceClear()">Filter löschen</a>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="filter-option"
      :class="{ '--is-active': activeButton === 4 }"
      v-if="$store.getters.isB2b"
    >
      <Button
        appearance="secondary"
        class="--flex-button"
        :class="{ '--is-active': activeButton === 4 }"
        @click="showFilter(4)"
      >
        Lieferzeit
        <i class="icon icon-angle-up" v-if="activeButton === 4"></i>
        <i class="icon icon-angle-down" v-else></i>
      </Button>
      <div class="filter-panel panel --has-no-padding form__check" v-if="activeButton === 4">
        <ul>
          <li>
            <vue-slider
              v-if="loadedCash"
              v-model="b2bTime"
              :data="getDeliveryTimeSteps"
              :tooltip="'none'"
            ></vue-slider>
          </li>
          <li v-if="b2bTime === 0">schnellstmöglich</li>
          <li v-else-if="b2bTime === 1">Sofort</li>
          <li v-else-if="b2bTime > 1 && b2bTime <= 14">in {{ b2bTime }} Tagen versandfertig</li>
          <li v-else-if="b2bTime > 14">am {{ getDeliveryReadyDateString(b2bTime) }} versandfertig</li>
          <li v-else>Alle Lieferzeiten anzeigen</li>
          <li class="--button-line">
            <Button appearance="primary" @click="showFilter(4)">Filter anwenden</Button>
            <a @click="level3ResetB2bTime()">Filter löschen</a>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="filter-option"
      :class="{ '--is-active': activeButton === 5 }"
      v-if="$store.getters.isB2b"
    >
      <Button
        appearance="secondary"
        class="--flex-button"
        :class="{ '--is-active': activeButton === 5 }"
        @click="showFilter(5)"
      >
        Anzahl
        <i class="icon icon-angle-up" v-if="activeButton === 5"></i>
        <i class="icon icon-angle-down" v-else></i>
      </Button>
      <div class="filter-panel panel --has-no-padding form__check" v-if="activeButton === 5">
        <ul>
          <li>
            <vue-slider v-if="loadedCash" v-model="b2bQty" :min="0" :max="1000" :tooltip="'none'"></vue-slider>
          </li>
          <li class="--price-filter">
            <div>
              <span>Ihre benötigte Anzahl</span>
              <input type="text" class="form__control" v-model="b2bQty" />
            </div>
          </li>
          <li class="--button-line">
            <Button appearance="primary" @click="showFilter(5)">Filter anwenden</Button>
            <a @click="level3ResetB2bQty()">Filter löschen</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="filter-option --is-free-search">
      <i class="icon icon-search"></i>
      <input type="search" placeholder="Suche" class="form__control" v-model="level3FreeSearch" />
    </div>
    <div class="filter-option" v-if="$store.getters.isAdminMode">
      Admin-Filter:
      <input type="text" placeholder="<|>tt.mm.jjjj" v-model="adminDate" class="form__control" style="width: 120px;" />
      <input type="text" placeholder="<|>100" v-model="adminQty" class="form__control" style="width: 80px;" />
    </div>
    <div
      class="filter-tags"
      v-if="
        (loadedCash &&
          ($store.getters.getLevel3Filter.brands.length > 0 ||
            $store.getters.getLevel3Filter.categories.length > 0 ||
            priceRange[0] !== filterCache.min ||
            priceRange[1] !== filterCache.max ||
            $store.getters.getLevel3Filter.attributes.length > 0 ||
            level3FreeSearch !== '' ||
            $store.getters.getLevel3Filter.b2b.qty > 0 ||
            $store.getters.getLevel3Filter.b2b.time > 0))
      "
    >
      <span v-for="(category, index) in $store.getters.getLevel3Filter.categories" :key="index">
        {{ category }}
        <span>
          <i class="icon icon-times" @click="level3CategoryChange(false, category)"></i>
        </span>
      </span>

      <span v-for="(brand, index) in $store.getters.getLevel3Filter.brands" :key="index">
        {{ brand }}
        <span>
          <i class="icon icon-times" @click="level3BrandChange(false, brand)"></i>
        </span>
      </span>

      <span
        v-if="
          priceRange[0] !== filterCache.min || priceRange[1] !== filterCache.max
        "
      >
        {{ priceRange[0] }} € - {{ priceRange[1] }} €
        <span>
          <i class="icon icon-times" @click="level3PriceClear()"></i>
        </span>
      </span>

      <span v-for="(attribute, index) in $store.getters.getLevel3Filter.attributes" :key="index">
        {{ attribute }}
        <span>
          <i class="icon icon-times" @click="level3AttributeChange(false, 'Bio')"></i>
        </span>
      </span>

      <span v-if="$store.getters.getLevel3Filter.b2b.qty > 0">
        Anzahl: {{ $store.getters.getLevel3Filter.b2b.qty }}
        <span>
          <i class="icon icon-times" @click="level3ResetB2bQty()"></i>
        </span>
      </span>

      <span v-if="b2bTime === 0">
        schnellstmöglich
        <span>
          <i class="icon icon-times" @click="level3ResetB2bTime()"></i>
        </span>
      </span>
      <span v-else-if="b2bTime === 1">
        Morgen versandfertig
        <span>
          <i class="icon icon-times" @click="level3ResetB2bTime()"></i>
        </span>
      </span>
      <span v-else-if="b2bTime > 1 && b2bTime <= 14">
        in {{ b2bTime }} Tagen versandfertig
        <span>
          <i class="icon icon-times" @click="level3ResetB2bTime()"></i>
        </span>
      </span>
      <span v-else-if="b2bTime > 14">
        am {{ getDeliveryReadyDateString(b2bTime) }} versandfertig
        <span>
          <i class="icon icon-times" @click="level3ResetB2bTime()"></i>
        </span>
      </span>
      <span v-else>
        Alle Lieferzeiten anzeigen
        <span>
          <i class="icon icon-times" @click="level3ResetB2bTime()"></i>
        </span>
      </span>

      <span v-if="level3FreeSearch !== ''">
        {{ level3FreeSearch }}
        <span>
          <i class="icon icon-times" @click="level3FreeSearch = ''"></i>
        </span>
      </span>

      <a @click="clearAllFilters()">Alle Filter löschen</a>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import Button from '@/components/Common/Button';
import { logicMixin } from '@/mixins/LogicMixin';

export default {
  name: 'FilterCatalogLevel3',
  components: { Button },
  mixins: [logicMixin],
  data: function () {
    return {
      activeButton: 0,
      filterCache: {},
      loadedCash: false,
      brandSearch: '',
      categorySearch: '',
      priceRange: [0, 100],
    };
  },
  created: function () {
    this.$root.$on('level3Loaded', () => {
      this.createFiltersLevel3();
    });
    this.createFiltersLevel3();
  },
  mounted () {
    document.addEventListener('click', this.clickOutside);
  },
  destroyed () {
    document.removeEventListener('click', this.clickOutside);
  },
  methods: {
    selectMin() {
      this.$refs.minPrice.select();
    },
    selectMax() {
      this.$refs.maxPrice.select();
    },
    showFilter: function (index) {
      if (this.activeButton === 0 || this.activeButton !== index) {
        this.activeButton = index;
      } else {
        this.activeButton = 0;
      }
    },
    createFiltersLevel3: function () {
      this.filterCache = {
        brands: [],
        categories: [],
        min: 0,
        max: 0,
      };
      this.$store.getters.getListItemsLevel3.forEach((product) => {
        var price = 0;
        if (this.$store.getters.getLevel3Filter.useB2cPrices) {
          price = this.getPriceRawForGroup(product, this.$store.getters.getUserGroupId, false);
        } else {
          price = this.getPriceRaw(product);
        }

        if (this.filterCache.min === 0 || this.filterCache.min > price) {
          this.filterCache.min = Math.floor(price);
        }
        if (this.filterCache.max < price) {
          this.filterCache.max = Math.ceil(price);
        }
        if (product.category !== undefined) {
          product.category.forEach(cat => {
            if (
              cat !== '' &&
              cat
                .toLowerCase()
                .includes(this.categorySearch.toLowerCase()) &&
              !this.filterCache.categories.includes(cat)
            ) {
              this.filterCache.categories.push(cat);
            }
          });
        }

        product.attributes.forEach((attribute) => {
          if (
            attribute.name === 'Marke' &&
            attribute.value[0]
              .toLowerCase()
              .includes(this.brandSearch.toLowerCase()) &&
            !this.filterCache.brands.includes(attribute.value[0])
          ) {
            this.filterCache.brands.push(attribute.value[0]);
          }
        });
      });

      const newMin = this.$store.getters.getLevel3Filter.priceMin;
      if (newMin > this.filterCache.min) {
        Vue.set(this.priceRange, 0, newMin);
      } else {
        Vue.set(this.priceRange, 0, this.filterCache.min);
      }
      const newMax = this.$store.getters.getLevel3Filter.priceMax;
      if (newMax < this.filterCache.max) {
        Vue.set(this.priceRange, 1, newMax);
      } else {
        Vue.set(this.priceRange, 1, this.filterCache.max);
      }

      this.filterCache.brands.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });

      this.filterCache.categories.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });

      this.loadedCash = true;
    },
    level3BrandChange: function (checked, brand) {
      if (checked) {
        this.$store.commit('addLevel3FilterBrand', brand);
      } else {
        this.$store.commit('removeLevel3FilterBrand', brand);
      }
    },
    level3BrandClear: function () {
      this.$store.commit('clearLevel3FilterBrand');
      document.getElementsByClassName('brand-input').forEach((el) => {
        if (el.checked) {
          el.checked = false;
        }
      });
      this.showFilter(1);
    },
    level3CategoryChange: function (checked, category) {
      if (checked) {
        this.$store.commit('addLevel3FilterCategory', category);
      } else {
        this.$store.commit('removeLevel3FilterCategory', category);
      }
    },
    level3CategoryClear: function () {
      this.$store.commit('clearLevel3FilterCategory');
      document.getElementsByClassName('category-input').forEach((el) => {
        if (el.checked) {
          el.checked = false;
        }
      });
      this.showFilter(6);
    },
    level3PriceChange: function () {
      this.$store.commit('setLevel3FilterMinPrice', this.priceRange[0]);
      this.$store.commit('setLevel3FilterMaxPrice', this.priceRange[1]);
    },
    level3PriceClear: function () {
      Vue.set(this.priceRange, 0, this.filterCache.min);
      Vue.set(this.priceRange, 1, this.filterCache.max);
      this.$store.commit('setLevel3FilterMinPrice', this.filterCache.min);
      this.$store.commit('setLevel3FilterMaxPrice', this.filterCache.max);
      this.$store.commit('setLevel3FilterUseB2cPrices', false);
      this.activeButton = 0;
    },
    level3AttributeChange: function (checked, attribute) {
      if (checked) {
        this.$store.commit('addLevel3FilterAttribute', attribute);
      } else {
        this.$store.commit('removeLevel3FilterAttribute', attribute);
      }
    },
    level3AttributesClear: function () {
      this.brandSearch = '';
      this.categorySearch = '';
      this.$store.commit('clearLevel3FilterAttribute');
      document.getElementsByClassName('attribute-input').forEach((el) => {
        if (el.checked) {
          el.checked = false;
        }
      });
      this.showFilter(3);
    },
    clearAllFilters: function () {
      this.level3BrandClear();
      this.level3CategoryClear();
      this.level3PriceClear();
      this.level3AttributesClear();
      this.level3ResetB2bQty();
      this.level3ResetB2bTime();
      this.level3FreeSearch = '';
      this.adminDate = '';
      this.adminQty = '';
    },
    level3ResetB2bQty: function () {
      this.$store.commit('setLevel1FilterB2bQty', 0);
      this.$store.commit('setLevel3FilterB2bQty', 0);
    },
    level3ResetB2bTime: function () {
      this.$store.commit('setLevel1FilterB2bTime', -1);
      this.$store.commit('setLevel3FilterB2bTime', -1);
    },
    level3UseB2cPrices: function (checked) {
      this.$store.commit('setLevel3FilterUseB2cPrices', checked);
      this.createFiltersLevel3();
    },
    clickOutside (e) {
      e.stopPropagation();

      if (!this.$el.contains(e.target) || e.target === this.$el) {
        this.activeButton = 0;
      }
    }
  },
  computed: {
    getDeliveryTimeSteps() {
      var times = [];
      var max = 0;
      this.$store.getters.getListItemsLevel3.forEach(item => {
        if (item.stock_quantity < this.boxQty) {
          times.push(this.getCalculatedTime(item));
        } else {
          const t = this.getCalculatedTime(item);
          if (t > max) {
            max = t;
          }
        }
      });
      times = times.filter(i => i > max);
      times.sort((a, b) => a - b);
      times.unshift(0);
      times = [...new Set(times)];
      times.push(-1);
      return times;
    },
    minInput: {
      get() {
        return this.priceRange[0];
      },
      set(value) {
        value = parseInt(value);
        if (!isNaN(value) && value < this.priceRange[1]) {
          Vue.set(this.priceRange, 0, value);
          this.$store.commit('setLevel3FilterMinPrice', value);
        }
      },
    },
    maxInput: {
      get() {
        return this.priceRange[1];
      },
      set(value) {
        value = parseInt(value);
        if (!isNaN(value) && value > this.priceRange[0]) {
          Vue.set(this.priceRange, 1, value);
          this.$store.commit('setLevel3FilterMaxPrice', value);
        }
      },
    },
    level3FreeSearch: {
      get() {
        return this.$store.getters.getLevel3Filter.freeSearch;
      },
      set(value) {
        this.activeButton = 0;
        this.$store.commit('setLevel3FilterFreeSearch', value);
      },
    },
    adminDate: {
      get() {
        return this.$store.getters.getLevel3Filter.adminDate;
      },
      set(value) {
        this.activeButton = 0;
        this.$store.commit('setLevel3FilterAdminDate', value);
      },
    },
    adminQty: {
      get() {
        return this.$store.getters.getLevel3Filter.adminQty;
      },
      set(value) {
        this.activeButton = 0;
        this.$store.commit('setLevel3FilterAdminQty', value);
      },
    },
    b2bQty: {
      get() {
        return this.$store.getters.getLevel3Filter.b2b.qty;
      },
      set(value) {
        if (value <= 1000) {
          this.$store.commit('setLevel1FilterB2bQty', value);
          this.$store.commit('setLevel3FilterB2bQty', value);
          if (parseInt(value) > 0) {
            this.$store.commit('setSelectedQty', { qty: value, store: this.$store });
          } else if (parseInt(value) === 0) {
            this.$store.commit('setSelectedQty', { qty: 1, store: this.$store });
          }
        }
      },
    },
    b2bTime: {
      get() {
        return this.$store.getters.getLevel3Filter.b2b.time;
      },
      set(value) {
        this.$store.commit('setLevel1FilterB2bTime', value);
        this.$store.commit('setLevel3FilterB2bTime', value);
      },
    }
  },
};
</script>

<style lang="scss">
@import '../assets/styles/components/filter-catalog';
</style>
